module.exports = __webpack_public_path__ + "img/new_password.0bcbb643.png";